import type { FaireProductEntity } from "../../entity_types/product";

export const p_60yjgd5qev: FaireProductEntity = {
  token: "p_60yjgd5qev",
  type: "product",
  name: "IMMUNITY SPRAY | 8 oz",
  brandToken: "b_5dagse75md",
  brandName: "Rowe Casa Organics",
  imageUrl:
    "https://cdn.faire.com/fastly/ac40811f519af8db11c75d6401c08de66a9a07c0114dd94d82fd20ff61ffc742.jpeg",
  galleryImageUrls: [],
  priceDollars: 16.8,
  description:
    "Concerned about all of the air-borne germs in your house, office, or car but don’t want to use toxic Lysol? Now you can combat airborne germs with our safe and effective, antibacterial & antiviral essential oil-infused Immunity Spray.⠀⠀\n\nTO USE: Shake well. Spray liberally in room as needed.\n\nINGREDIENTS: DISTILLED WATER, COLLOIDAL SILVER, 100% PURE THERAPEUTIC GRADE ESSENTIAL OILS: CLOVE, LEMON, CINNAMON BARK, EUCALYPTUS RADIATA, ROSEMARY, ORANGE, LEMONGRASS, TEA TREE, FRANKINCENSE, GERANIUM, THYME.",
  tags: [],
  msrpDollars: 24,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T19:26:01.307Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
